module.exports = __webpack_public_path__ + "images/emoji/telephone_receiver.4a905d21be015bc3c67c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/telephone_receiver.png
// module id = S3J6
// module chunks = 24